import React, { useId } from "react";
import { Backdrop, Button, CircularProgress, Grid} from "@material-ui/core";

import Tooltip from "@material-ui/core/Tooltip";
import PageTitle from "../../../components/PageTitle";
import useStyles from "../../../themes/style.js";
import { useState,useEffect } from "react";
import axios from "axios";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  FormControl,
  InputLabel,
  TextField,
  TextareaAutosize,
  TablePagination,
  Typography,
  Card,
  CardContent,
   CardHeader,
  Chip
} from "@material-ui/core";
import { } from "@material-ui/core";
import { useForm, useFieldArray } from "react-hook-form";
import { Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { IoAdd, IoRemove } from "react-icons/io5";
import Switch from "@material-ui/core/Switch";
import { useLocation } from "react-router-dom";
import { useNotification } from "../../../hooks/useNotification.js";
import { makeStyles } from "@material-ui/core/styles";
import { MdEdit } from "react-icons/md";
import moment from "moment";
import NoDataFound from "../../../components/NoDataFound/index.js";


const useCardStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 400,
    margin: "auto",
    border: `1px solid ${theme.palette.divider}`,

    boxShadow: theme.shadows[3],
    borderRadius: theme.shape.borderRadius,
  },
  statusChip: {
    marginTop: theme.spacing(1),
    fontWeight: "bold",
    color: theme.palette.common.white,
  },
  reterned: {
    backgroundColor: theme.palette.success.main,
    borderTop: `3px solid ${theme.palette.success.dark}`,
  },
  inPossession: {
    backgroundColor: "#3f51b5",
  },
  root: {
    "& .Mui-disabled": {
      color: "#4caf50 !important", // Success green for disabled
    },
  },
  switchBase: {
    color: "#ff4081", // Thumb color when unchecked (pink)
    "&.Mui-checked": {
      color: "#4caf50", // Thumb color when checked (green)
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      backgroundColor: "#4caf50 !important", // Track color when disabled
    },
  },
  track: {
    backgroundColor: '#bdbdbd', // Track color when unchecked (gray)
    '&.Mui-checked': {
      backgroundColor: '#4caf50', // Track color when checked (green)
    },
    '&.Mui-disabled': {
      backgroundColor: '#9e9e9e', // Track color when disabled (light gray)
    },
  },
}));

const EmployeeAssetManagement = () => {
  const classes = useStyles();
  const cardClasses = useCardStyles();

  const [loader, setLoader] = useState(false);
  const token = localStorage.getItem("token");


  const location = useLocation();

 

  const [assetsDetails, setAssetsDetails] = useState([]);



  const handleNotificationCall = useNotification();

  const queryParams = new URLSearchParams(location.search);

  const userID = queryParams.get("userId");
  console.log(userID);


   useEffect(() => {
    fetchData();
  }, []);
 
  const fetchData = async () => {
    setLoader(true);

    try {
      const viewAlldata = await axios.get(
        `${process.env.REACT_APP_SERVER}assets/viewUserAssets?userId=${userID}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        },
      );
      if (viewAlldata.data.status) {
        setAssetsDetails(viewAlldata.data.data);
        setLoader(false);
        
        // setCount(viewAlldata.data.count);
      } else {
        handleNotificationCall("error", viewAlldata.data.message);
      }
    } catch (error) {
      console.log(error);
      handleNotificationCall("error", "Error Happend!");
    } finally {
      setLoader(false);
    }
  };

  



  console.log(assetsDetails);

 


 

 

  const AssetCard = ({assetsDetails }) => {
  
  
    
  
    return (
      <Card className={cardClasses.card}  style={{borderTop: assetsDetails.assetStatus ? "3px solid #3f51b5" : "3px solid #10B981" ,height:"100%",position:"relative",marginBottom:"50px",paddingBottom:"30px"

      }} >
        <Box display="flex" justifyContent="space-between" alignItems="center"> 
        <CardHeader
          title={assetsDetails.assetName}
          subheader={assetsDetails.assetType}
          titleTypographyProps={{ variant: "h4", color: "primary",style:{fontSize:"20px",fontWeight:600}}}
          subheaderTypographyProps={{ variant: "subtitle1", color: "textSecondary" }}
        />
          </Box>
        <CardContent>
          <Typography variant="body2" color="textSecondary">
            {assetsDetails.assetDescription}
          </Typography>
        
        <br />

          <div style={{position:"absolute",bottom:"15px",left:"15px"}} >
          <Typography variant="body2" color="dark">
            <span style={{color:"#3f51b5"}}>In Possession Date:  </span> {`${moment(assetsDetails.createdAt).format("DD-MM-YYYY")}`}
            <br/>
            {!assetsDetails.assetStatus && <><span style={{color:"#10B981"}}>Reterned Date:</span> {moment(assetsDetails.givenTime).format("DD-MM-YYYY")}</>}
          </Typography>


          <Chip
            label={assetsDetails.assetStatus ?  "In Possession" : "Reterned"}
            className={`${cardClasses.statusChip}`}
            style={{backgroundColor: assetsDetails?.assetStatus ?  "#3f51b5": "#10B981"}}
          />
          </div>
        </CardContent>
      </Card>
    );
  };

  return (
    <>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Company Assets" />
        </Grid>
        {/* <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={handleAssetsModalOpen}
        >
          Add Assets Details
        </Button> */}
      </Grid>
      {assetsDetails.length === 0 && <NoDataFound height="80vh" message="No Data Found"/>}
      <Grid container spacing={2}  style={{ marginTop: 20 }}>
        {assetsDetails.map((item)=>(
           <Grid item key={item._id} xs={12} sm={6} md={4} lg={3}>
           <AssetCard
             assetsDetails={item}
           />
         </Grid>
        ))}
     
    
    </Grid>



          {/* <Grid
              container
              spacing={2}
              className={classes.pagination}
              style={{ marginTop: "30px" }}
            >
              <TablePagination
                rowsPerPageOptions={[10]}
                component="div"
                count={count}
                rowsPerPage={10}
                page={page}
                onPageChange={handleChangePage}
              />
            </Grid> */}


     
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default EmployeeAssetManagement;
